import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from "@angular/core";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

/**
 * This component implements a global switch component. 
 * 
 * Usage : 
 * ```
 *  <h-switch-button
                class="toggle-button"
                (checked)="switchFilterClicked($event)"
                i18n="@@hermes-grid-filter.filter-available-online"
                >Available Online</h-switch-button
            >
 * ```
 */
@Component({
    standalone: true,
    selector: "h-switch-button",
    imports: [SrOnlyNoSnippetDirective],
    templateUrl: "./switch-button.component.html",
    styleUrls: ["./switch-button.component.scss"],
})
export class SwitchButtonComponent {
    @ViewChild("switchInput")
    public switchInput!: ElementRef;

    @Input()
    public id!: string;
    @Input()
    public labelledById?: string;
    @Input()
    public describedById?: string;
    @Output()
    public checked = new EventEmitter<boolean>();
    @Input()
    public dataTestId?: string;
    @Input()
    public isSwitchEnabled: boolean = false;

    public handleActivate(event: Event) {
        // Mandatory to prevent scroll down (navigator/computer behaviour) on space.down.
        event.preventDefault();
        this.switchInput.nativeElement.click();
    }
    public switchClicked(): void {
        this.isSwitchEnabled = !this.isSwitchEnabled;
        this.checked.emit(this.isSwitchEnabled);
    }
}
